import React from "react";
import { observer } from "mobx-react-lite";
import { Box, ErrorExclamationView, Input, Label, theme } from "Application";
import { IStudentSessionReportViewModel } from "Views/Students/Student/StudentReports/Form/Interfaces/IStudentSessionReportViewModel";
import { Container, Reference, ReferenceInnerContainer, Main, FormField, ErrorContainer } from "./SessionReportSessionPlan.styles";

export const SessionReportSessionPlan: React.FC<{ viewModel: IStudentSessionReportViewModel }> = observer(({ viewModel }) => {
    const isMobile = (viewModel as { isMobile?: boolean }).isMobile ?? false;
    return (
        <Box flexBox flexDirection={"column"} gap="20px">
            <FormField>
                <Box position="relative" display="inline-block">
                    <Label fontStyle="h2">Session Plan</Label>
                    <ErrorContainer>
                        <ErrorExclamationView haveError={!!viewModel.getError("sessionPlan")} validationMessage={() => viewModel.getError("sessionPlan")} />
                    </ErrorContainer>
                </Box>
                <Input
                    multiline={true}
                    displayName={"(What personal target(s) was the session working towards?)"}
                    value={() => viewModel.getValue("sessionPlan") ?? ""}
                    command={viewModel.updateSessionPlanCommand}
                    placeholder={"Please add notes..."}
                    rows={4}
                    isRequired={false}
                    showClearText={!isMobile}
                />
            </FormField>

            <FormField>
                <Box position="relative" display="inline-block">
                    <Label fontStyle="h2">Session Feedback</Label>
                    <ErrorContainer>
                        <ErrorExclamationView haveError={!!viewModel.getError("sessionFeedback")} validationMessage={() => viewModel.getError("sessionFeedback")} />
                    </ErrorContainer>
                </Box>
                <Input
                    multiline={true}
                    displayName={
                        "(How effective was the session in working towards personal targets? Actions for next session? Risk assessment/ behaviour plan need updating? Any minor concerns risen from the session? Concerning comments?)"
                    }
                    value={() => viewModel.getValue("sessionFeedback") ?? ""}
                    command={viewModel.updateSessionFeedbackCommand}
                    placeholder={"Please add notes..."}
                    rows={4}
                    isRequired={false}
                    showClearText={!isMobile}
                />
            </FormField>
        </Box>
    );
});
